export default {
  tabLabelOptions: [],
  labelUseCounter: {}
}
